export default {
  SET_AFFECTED_PERMISSION: 'SET_AFFECTED_PERMISSION',

}
